<template>
  <component :is="layout">
    <registration-form />
  </component>
</template>

<script>
import RegistrationForm from "../components/registration_form/RegistrationForm";

export default {
  name: "Registration.vue",
  components: {
    RegistrationForm
  },
  data() {
      return {
          layout: 'simple-layout'
      }
  }
};
</script>

<style scoped lang="sass">
</style>
